import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Subscription } from 'rxjs';
import { CentroDistribuicaoService } from 'src/app/centro-distribuicao/shared/centro-distribuicao.service';
import { LimiteCdService } from 'src/app/centro-distribuicao/shared/limite-cd.services';
import { EventEmitterService } from 'src/app/shared/services/event-emiter.service';
import { ClienteService } from '../../clientes/shared/cliente.service';
import { Paginacao } from '../paginacao/shared/paginacao';
import { CarrinhoService } from './shared/carrinho.service';
import { Carrinho } from './shared/carrinhos';
import { DescontosService } from './shared/descontos.service';
import { CarrinhoItem } from './shared/item-carrinho';
import { CampanhaPatrocinadoService } from 'src/app/shared/services/campanha-patrocinado.service';
import { Produto } from 'src/app/produtos/shared/produto';
import { CepService } from 'src/app/ceps/shared/cep.service';

@Component({
  selector: 'app-carrinho',
  templateUrl: './carrinho.component.html',
  styleUrls: ['./carrinho.component.css'],
  providers: [DescontosService]
})
export class CarrinhoComponent implements OnInit, OnDestroy {
  public paginacao: Paginacao;
  public carrinho: Carrinho;
  public carrinhoItens: Array<CarrinhoItem> = [];
  public valorInicial: Carrinho = {
    carrinho_id: null,
    centro_distribuicao_id: null,
    preco: 0,
    quantidade: 0
  };

  public pedido: any;
  public descontos = 0;
  private limparCarrinhoResp = false;

  private carrinho$: Subscription;
  private afterAddCarrinho$: Subscription;
  private carrinhoItens$: Subscription;
  private afterLogout$: Subscription;
  private afterLogin$: Subscription;

  private limparCarrinho$: Subscription;
  private voltarLoja$: Subscription;

  constructor(
    private carrinhoService: CarrinhoService,
    private clienteService: ClienteService,
    private descontosService: DescontosService,
    private cdService: CentroDistribuicaoService,
    private limiteCdService: LimiteCdService,
    private localStorageService: LocalStorageService,
    private campanhaPatrocinadoService: CampanhaPatrocinadoService,
    private cepService: CepService,
  ) {
    this.carrinho = this.valorInicial;
  }

  private limparCarrinho(idCd) {
    this.limpar(this.carrinhoService.carrinhoId);
    if (this.limparCarrinhoResp) {
      this.limiteCdService.fecharLimiteCd();
    }
    this.localStorageService.remove('cdOriginal');
  }

  private voltarLoja(idCd: any) {
    this.cdService.buscaEAlteraCd(idCd);
    this.limiteCdService.fecharLimiteCd();
    this.localStorageService.remove('cdOriginal');
  }

  private buscarPedido() {
    if (this.carrinhoService.logged) {
      const pedido$ = this.clienteService
        .getPedidoEmProcesso()
        .subscribe((res: any) => {
          if ('pedido' in res) {
            this.pedido = res.pedido;
          }
          pedido$.unsubscribe();
        });
    }
  }

  private buscarCarrinho() {
    this.carrinho$ = this.carrinhoService
      .buscarCarrinho(this.cdService.id)
      .subscribe((res: any) => {
        if (res.data) {
          this.carrinho = res.data;
          if (this.validarCdDoCarrinho()) {
            this.buscarCarrinhoItens();
          }
          return this.carrinho;
        }

        this.resteInfoCarrinho();
      });
  }

  private buscarCarrinhoItens() {
    this.carrinhoItens$ = this.carrinhoService
      .buscarCarrinhoItens(this.cdService.id)
      .subscribe(res => {
        this.carrinhoItens = res.data;
        this.paginacao = res.paginator;
      });
  }

  afterAddItem() {
    this.afterAddCarrinho$ = this.carrinhoService.afterAddCarrinho$.subscribe(
      (info) => {
        if (info && info.atualizaPedido) {
          this.buscarPedido();
        }

        this.buscarCarrinho();
        this.buscaDescontos();
      }
    );
  }

  private buscaDescontos() {
    if (this.carrinhoService.logged) {
      this.descontosService.listar().then(data => {
        this.descontos = data.descontos.total;
      });
    }
  }

  private buscarInfoCarrinho() {
    this.buscarPedido();
    this.buscarCarrinho();
    this.buscaDescontos();
  }

  private afterLogout() {
    this.afterLogout$ = this.clienteService.afterLogout$.subscribe(() => {
      this.resteInfoCarrinho();
    });
  }

  private afterLogin() {
    this.afterLogin$ = this.clienteService.afterLogin$.subscribe(() => {
        this.buscarPedido();
    });
  }

  ngOnInit() {
    this.buscarInfoCarrinho();
    this.afterAddItem();
    this.afterLogout();
    this.afterLogin();
    this.limparCarrinho$ = EventEmitterService.get('limpar_carrinho').subscribe((idCd: any) => { this.limparCarrinho(idCd) });
    this.voltarLoja$ = EventEmitterService.get('voltar_loja').subscribe((idCd: any) => { this.voltarLoja(idCd) });
  }

  ngOnDestroy() {
    this.afterLogout$.unsubscribe();

    if (this.carrinho$) {
      this.carrinho$.unsubscribe();
    }

    if (this.carrinhoItens$) {
      this.carrinhoItens$.unsubscribe();
    }

    if (this.afterAddCarrinho$) {
      this.afterAddCarrinho$.unsubscribe();
    }

    this.limparCarrinho$.unsubscribe();
    this.voltarLoja$.unsubscribe();
  }

  private resteInfoCarrinho() {
    this.carrinho = this.valorInicial;
    this.carrinhoItens = [];
  }

  private validarCdDoCarrinho() {
    const cdCarrinhoId = this.carrinho.centro_distribuicao_id;
    const cdAtualId = this.cdService.id;
    const carrinhoPertenceAoCdAtual = cdCarrinhoId == cdAtualId;
    return carrinhoPertenceAoCdAtual;
  }


  limpar(carrinhoId) {
    if (this.pedido == null) {
      if (window.confirm('Tem certeza que deseja esvaziar o carrinho?')) {
        this.limparCarrinhoResp = true;
        const apagarCarrinho$ = this.carrinhoService
          .apagarCarrinnho(carrinhoId)
          .subscribe(() => {
            this.resteInfoCarrinho();
            apagarCarrinho$.unsubscribe();
          });
      }
    }
  }

  clienteLogado() {
    return this.clienteService.logged();
  }

  cliqueCaptureAds(produto: Produto) {
    this.campanhaPatrocinadoService.clique(produto);
  }
}
